import { useEffect, useState } from "react";
import { Switch } from "@mantine/core";

const MantineSwitch = (props:any) => {
  const { checked = false, label, onChange, color = "blue", disabled = false, classNames } = props;
  const [isChecked, setIsChecked] = useState(checked);

  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);

  const handleChange = (event:any) => {
    const newValue = event.currentTarget.checked;
    setIsChecked(newValue);
    if (onChange) {
      onChange(newValue); 
    }
  };

  return (
    <div className="flex flex-col">
      {label && <div className="text-sm font-medium mb-1">{label}</div>}
      <div className="flex items-center gap-2">
        <Switch
          classNames={classNames}
          checked={isChecked}
          onChange={handleChange}
          color={color}
          disabled={disabled}
        />
        <span className="text-sm font-medium">
          {isChecked ? "Enabled" : "Disabled"}
        </span>
      </div>
    </div>
  );
};

export default MantineSwitch;
